var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"appleid-signin","data-color":"white","data-mode":"logo-only","data-border":"false","data-type":"sign in","data-border-radius":"10","data-size":"38"},on:{"click":_vm.signInWithApple}})
}
var staticRenderFns = []

export { render, staticRenderFns }